import injectSheet from 'react-jss';

import mccLogoWhiteSrc from '../../images/mcc-logo-white.png';

const styles = () => ({
    poweredBy: {
        display: 'block',
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        textAlign: 'center',
        color: '#fff',
        height: 50,
        backgroundColor: '#414042',
        fontSize: 13,
        verticalAlign: 'middle',
        lineHeight: '50px',
        textDecoration: 'none'
    },
    mccLogoWhite: {
        height: 24,
        marginLeft: 10
    }
});

const MCCFooter = props => {
    const {classes = {}} = props;
    const {poweredBy, mccLogoWhite} = classes;

    return (
        <a className={poweredBy} href="https://www.memberclosingcenter.com" target="_blank" rel="noopener noreferrer">
            <span>Powered by The Member Closing Center</span>
            <img src={mccLogoWhiteSrc} className={mccLogoWhite} alt="" />
        </a>
    );
};

export default injectSheet(styles)(MCCFooter);
